import { EncodeFormData } from "../FormHelpers";

export const ResolveSubmitForm = (
    e, 
    setErrorMessage, 
    setIsLoading, 
    setShowSuccess, 
    recaptchaValue, 
    state, 
    intl
  ) => {
  setIsLoading(true);
  e.preventDefault();
  const form = e.target;

  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: EncodeFormData({
      "form-name": form.getAttribute("name"),
      "g-recaptcha-response": recaptchaValue,
      ...state,
    }),
  })
  .then((response) => {
    if (response.status === 200) {
      setIsLoading(false);
      setShowSuccess(true);
    } else {
      setIsLoading(false);
      setErrorMessage(
        intl.messages["component.form.contact_form.error_message_generic"]
      );
      console.error(response);
    }
    updateTagManager(response);
  })
  .catch((err) => {
    setIsLoading(false);
    console.error(err);
  });
};

function updateTagManager(response)
{
    const location = document.location;
    
    // Manually remove the leading question mark, if there is one
    
    var searchParams = new URLSearchParams(location.search);
    var paramsMap = {};
    for (const [key, value] of searchParams.entries()) {
      paramsMap[key] = value;
    }
    let responseBody = '';
    response.text().then((text) => {
      responseBody = text;
    });
    // Blindly push to the dataLayer because this fires within GTM
    let value = {
      'event': 'formSubmit',
      'attributes': {
        'type': 'POST',
        'url': location.href,
        'queryParameters': paramsMap,
        'pathname': location.pathname,
        'hostname': location.hostname,
        'protocol': location.protocol,
        'fragment': location.hash,
        'statusCode': response.status,
        'statusText': response.statusText,
        'timestamp': new Date().toUTCString(),
        // Defer to jQuery's handling of the response
        'response': responseBody
      }
    }
    if(window.dataLayer)
    {
      window.dataLayer.push(value);
    }
}